// A licensable product's slug is compiled into every shipped binary of that product and
// sent on activation. The server matches on it exactly. So a slug that is wrong — or that
// merely differs in case or whitespace from what the binary sends — cannot be corrected
// afterwards from the server: the installed copies keep sending the old one and keep being
// refused. Normalising and checking here is the only cheap moment.

/** Canonical form: trimmed and lower-cased. Apply before validating or sending. */
export function normaliseProductSlug(raw) {
  return String(raw ?? '').trim().toLowerCase()
}

/**
 * Valid slugs are lower-case letters, digits and hyphens, starting with a letter or digit.
 * Deliberately narrow: the slug travels in a URL path (`/api/p/:productSlug/updates/...`),
 * so dots and slashes must never be accepted.
 */
export function isValidProductSlug(slug) {
  return /^[a-z0-9][a-z0-9-]*$/.test(slug)
}

export const PRODUCT_SLUG_RULE =
  'Slug must be lower-case letters, digits and hyphens, starting with a letter or digit.'
